<template>
  <a-modal
    v-model="visible"
    width="60%"
    :title="title"
    centered
    @ok="confirm"
  >
  <div class="contract">
    <p class="titleName">选择合同</p>
    <div class="itemBox">
      <p v-for="(item, i) in contractList" :key="i" :class="contractIndex === i ? 'item activeItem' : 'item'" @click="changeContract(item, i)">
        <a-radio class="contractName" :checked="contractIndex === i ? true : false">{{item.contractName}}</a-radio>
      </p>
    </div>
  </div>
  <div v-if="filterTerm()" class="contract">
    <p class="titleName clause">选择条款</p>
    <div class="itemBox">
      <p v-for="(term, i) in contractList[contractIndex].contractTermInfo" :key="i" :class="termIndex === i ? 'item activeItem' : 'item'" @click="changeTerm(term, i)">
        <a-radio class="contractName" :checked="termIndex === i ? true : false">{{term.name}}</a-radio>
      </p>
    </div>
  </div>
  </a-modal>
</template>

<script>
import { getContract } from '../api';

export default {
  name: 'SelectContract',
  props: {
    defaultContractCode: {
      type: String,
      default: ''
    },
    defaultTermCode: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      visible: false,
      title: '选择下单合同及条款',
      contractIndex: 0,
      contractList: [],
      termIndex: 0,
      form: {
        contractCode: '',
        contractTermCode: '',
        contractName: '',
        contractTermName: ''
      },
      isRefreshRule: false
    };
  },
  watch: {
    defaultContractCode:{
      async handler(value) {
        const res = await getContract({
          cargoOwnerCode: this.$store.state.user.customerCode,
          status: 'ENABLED',
          needAllContracts: true,
        })
        res.forEach((e, i) => {
          if(e.contractCode === value){
            this.form.contractCode = e.contractCode
            this.form.contractName = e.contractName
            this.contractIndex = i
            e.contractTermInfo.forEach((n, m) => {
              if(this.defaultTermCode === n.code) {
                this.form.contractTermCode = n.code
                this.form.contractTermName = n.name
                this.termIndex = m
              }
            })
          }
        })
      },
      immediate: true
    },
    async defaultTermCode(){
      const res = await getContract({
        cargoOwnerCode: this.$store.state.user.customerCode,
        status: 'ENABLED',
        needAllContracts: true,
      })
      res.forEach((e) => {
        if(e.contractCode === this.defaultContractCode){
          e.contractTermInfo.forEach((n, m) => {
            if(this.defaultTermCode === n.code) {
              this.form.contractTermCode = n.code
              this.form.contractTermName = n.name
              this.termIndex = m
            }
          })
        }
      })
    }
  },
  created(){
  },
  methods: {
    confirm() {
      this.visible = false
      this.$emit("success", this.form)
    },
    close() {
      this.visible = false
    },
    show(visible, isRefreshRule = false) {
      this.isRefreshRule = isRefreshRule;
      this.visible = true
      this.getContract()
    },
    changeContract(item, i){
      this.contractIndex = i
      this.form.contractCode = item.contractCode
      this.form.contractName = item.contractName
      if(this.isRefreshRule) {
        this.form.partBTenantId = item.partBTenantId
      }
      this.changeTerm(item.contractTermInfo[0], 0)
    },
    async getContract(){
      const res = await getContract({
        cargoOwnerCode: this.$store.state.user.customerCode,
        status: 'ENABLED',
        needAllContracts: true,
      })
      this.contractList = res || []
      if(res && res.length > 0 ){
        if(this.isRefreshRule) {
          this.form.partBTenantId = res[0].partBTenantId
        }
        if(!this.defaultContractCode){
          this.form.contractCode = res[0].contractCode
          this.form.contractName = res[0].contractName
          this.form.contractTermCode = res[0].contractTermInfo[0]?.code
          this.form.contractTermName = res[0].contractTermInfo[0]?.name
          this.contractIndex = 0
          this.termIndex = 0
        }else{
          res.forEach((e, i) => {
          if(e.contractCode === this.defaultContractCode){
            this.form.contractCode = e.contractCode
            this.form.contractName = e.contractName
            this.contractIndex = i
            e.contractTermInfo.forEach((n, m) => {
              if(this.defaultTermCode === n.code) {
                this.form.contractTermCode = n.code
                this.form.contractTermName = n.name
                this.termIndex = m
              }
            })
          }
        })
        }
       
      }
    },
    filterTerm() {
      const data = this.contractList[this.contractIndex]
      if(data && data.contractTermInfo && data.contractTermInfo.length > 0) return true
      return false
    },
    changeTerm(term, i) {
      this.termIndex = i
      this.form.contractTermCode = term.code
      this.form.contractTermName = term.name
    }
  },
}
</script>
<style lang="less" scoped>
.contract{
  width: 100%;
  padding: 0 20px;
  .titleName{
    font-size: 16px;
    color: #333;
    margin-bottom: 16px;
  }
  .clause{
    margin-top: 12px;
  }
  .itemBox{
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .item{
      width: 49%;
      height: 44px;
      margin-bottom: 20px;
      line-height: 44px;
      background: #F4F4F4;
      border-radius: 6px;
      padding: 0 20px;
      border: 1px solid #dddddd8c;
      &:hover{
        background: rgba(6, 184, 128, 0.08);
        border: 1px solid #06b880;
        .contractName{
          color: #06b880;
        }
      }
      .contractName{
        width: 100%;
        font-size: 14px;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: text-bottom;
      }
    }
    .activeItem{
      background: rgba(6, 184, 128, 0.08);
      border: 1px solid #06b880;
      .contractName{
        color: #06b880;
      }
    }
  }
}
</style>
